import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getChildSubCategories } from "../../../services/categories/child-subcategories";
import { edit, retreive } from "../../../actions/childSubCategory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getFilterGrouping } from "../../../actions/filters";
import Alert from "../../../components/alert/alert.component";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import CustomRadioInput from "../../../components/custom-input/custom-radio-input";
import CustomTextArea from "../../../components/custom-input/custom-textarea";
import MultiValueSelect from "../main-category/components/multi-value-select/multi-value-select";
import ImageUploaderField from "../../../components/img-uploader-field/img-uploader-field";
import DropdownSelect from "./components/drop-down-select/drop-down-select";
import CustomInput from "../../../components/custom-input/custom-input";
import HeadingSecondary from "../../../components/custom-heading/heading-secondary";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import { useDispatch } from "react-redux";

const Edit = () => {
  const dispatch = useDispatch();
  const query = new URLSearchParams(window.location.search);
  const id = query.get("id");

  const [loading, setLoading] = useState(true);
  const [newFilterData, setNewFilterData] = useState([]);
  const [parentCategory, setParentCategory] = useState({});

  const [formData, setFormData] = useState({
    subCategoryId: "",
    name: "",
    slug: "",
    displayName: "",
    description: "",
    metaTag: [],
    metaDescription: "",
    metaKeyword: [],
    seoKeyword: [],
    subCategories: [],
    show: true,
    image: "",
    showModal: false,
    serverSideFilterOptions: [],
    banner: "",
    isbase64: false,
    isBannerBase64: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const _res = await getChildSubCategories();
      setFormData((prev) => ({
        ...prev,
        subCategories: _res?.data,
      }));

      const res = await dispatch(retreive(id));
      const res1 = await dispatch(getFilterGrouping());
      const tempArr = res1?.data?.map((item) => ({
        value: item._id,
        label: item.title,
        isFixed: item.status,
      }));
      setNewFilterData(tempArr);

      const metaTagData = [];
      res?.metaTag &&
        res?.metaTag?.forEach((element) => {
          metaTagData.push({
            value: element,
            label: element,
          });
        });

      const metaKeywordData = [];
      res?.metaKeyword &&
        res?.metaKeyword?.forEach((_element) => {
          metaKeywordData.push({
            value: _element,
            label: _element,
          });
        });

      const seoKeywordData = [];
      res?.seoKeyword &&
        res?.seoKeyword?.forEach((element) => {
          seoKeywordData.push({
            value: element,
            label: element,
          });
        });

      const filterOptionsData = [];
      newFilterData?.forEach((item) => {
        res?.filter?.forEach((item1) => {
          if (item.value === item1) {
            filterOptionsData.push({
              value: item.value,
              label: item.label,
              isFixed: item.isFixed,
            });
          }
        });
      });

      setFormData((prev) => ({
        ...prev,
        name: res?.name,
        displayName: res?.displayName,
        slug: res?.slug,
        description: res?.description,
        metaTag: metaTagData,
        metaDescription: res?.metaDescription,
        metaKeyword: metaKeywordData,
        seoKeyword: seoKeywordData,
        serverSideFilterOptions: filterOptionsData,
        subCategoryId: res?.categoryId,
        show: res?.show,
        image: res?.image,
      }));
      setLoading(false);

      const getParentCategory = _res?.data.filter(
        (item) => item._id === res?.categoryId
      )[0];
      setParentCategory(getParentCategory);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    e.persist();
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = async () => {
    const {
      subCategoryId,
      name,
      displayName,
      slug,
      description,
      metaTag,
      metaDescription,
      metaKeyword,
      seoKeyword,
      show,
      filterOptions,
      image,
      isbase64,
      banner,
      isBannerBase64,
    } = formData;

    const metaTagData = [];
    metaTag?.forEach((element) => {
      metaTagData.push(element.value);
    });

    const metaKeywordData = [];
    metaKeyword?.forEach((_element) => {
      metaKeywordData.push(_element.value);
    });

    const seoKeywordData = [];
    seoKeyword?.forEach((element) => {
      seoKeywordData.push(element.value);
    });

    const filterOptionData = [];
    filterOptions?.forEach((element) => {
      filterOptionData.push(element.value);
    });

    const dataToSend = {
      name: name,
      slug: slug,
      displayName,
      _id: id,
      categoryId: subCategoryId,
      image: image,
      metaTag: metaTagData,
      metaDescription: metaDescription,
      metaKeyword: metaKeywordData,
      seoKeyword: seoKeywordData,
      description: description,
      show: show,
      isbase64,
      banner,
      isBannerBase64,
    };

    try {
      const res = await dispatch(edit(dataToSend));
      if (res) {
        toast(`${res.data}`, { containerId: "B" });
      }
    } catch (error) {
      console.log("error is : ", error);
    }
  };

  const getCategoriesTree = () => {
    return (
      Array.isArray(formData?.subCategories) &&
      formData?.subCategories.map((item, index) => (
        <option key={item?._id ?? index} value={item._id}>
          {`${item?.category?.maincategory?.name ?? ""} >  ${
            item?.category?.name ?? ""
          } > ${item?.name ?? ""}`}
        </option>
      ))
    );
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async (e, key) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prev) => ({ ...prev, [key]: base64Image, isbase64: true }));
  };

  const handleBannerImageChange = async (e, key) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prev) => ({
      ...prev,
      [key]: base64Image,
      isBannerBase64: true,
    }));
  };

  const changeInputTags = (e, key) => {
    const data = e?.map((item) => ({
      value: item.value,
      label: item.value,
    }));
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}

      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary>Edit Child Sub Category</HeadingPrimary>

        <div style={{ fontSize: ".9rem" }}>
          <Link to="/admin/child-subcategories">Child Sub Categories </Link>
          /&nbsp;Create Sub Child Category
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div
            className="card p-0"
            style={{
              border: "1px solid #dcdcdc",
            }}
          >
            <div className="card-body p-0">
              <HeadingSecondary>Edit child category</HeadingSecondary>
              <Alert />

              <form className="forms-sample m-3">
                <CustomInput
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.name}
                />

                <CustomInput
                  label="Display Name"
                  name="displayName"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.displayName}
                />

                <CustomInput
                  label="Slug"
                  name="slug"
                  type="text"
                  placeholder="Slug"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.slug}
                />

                <DropdownSelect
                  label="Select parent category"
                  id="category"
                  getOptions={getCategoriesTree}
                  name="subCategoryId"
                  labelStyles={{ fontWeight: "bold" }}
                  handleImageChange={handleChange}
                  value={parentCategory}
                />

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Image upload"
                  buttonText="Choose image"
                  name="image"
                  onChange={(e) => handleImageChange(e, "image")}
                />

                <div className="input-group col-xs-12">
                  <img
                    src={formData?.image && formData?.image}
                    alt="main-img"
                    width="100"
                    height="50"
                    style={{ marginBottom: "2rem" }}
                  />
                </div>

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Banner upload"
                  buttonText="Choose image"
                  name="banner"
                  onChange={(e) => handleBannerImageChange(e, "banner")}
                />

                <div className="input-group col-xs-12">
                  <img
                    src={formData?.banner && formData?.banner}
                    alt="banner"
                    width="100"
                    height="50"
                    style={{ marginBottom: "2rem" }}
                  />
                </div>

                {!loading && (
                  <MultiValueSelect
                    label="Meta Tags"
                    defaultValue={formData.metaTag}
                    name="metaTags"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaTag")}
                  />
                )}

                {!loading && (
                  <MultiValueSelect
                    label="Meta Keywords"
                    defaultValue={formData.metaKeyword}
                    name="metaKeyword"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Meta Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="metaDescription"
                  rows={6}
                  value={formData.metaDescription}
                  onChange={handleChange}
                />

                {!loading && (
                  <MultiValueSelect
                    label="Seo Keywords"
                    defaultValue={formData.seoKeyword}
                    name="seoKeyword"
                    onChange={(value) => changeInputTags(value, "seoKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="description"
                  rows={6}
                  value={formData.description}
                  onChange={handleChange}
                />

                <div className="form-group">
                  <label
                    style={{ fontWeight: "bold" }}
                    className="col-sm-3 col-form-label"
                  >
                    Show in Header
                  </label>
                  <div className="col-sm-12">
                    <CustomRadioInput
                      label="Yes"
                      required={true}
                      type="radio"
                      id="radio1"
                      name="membershipRadios"
                      checked={formData.show === true}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: true })}
                    />
                  </div>
                  <div className="col-sm-5">
                    <CustomRadioInput
                      label="No"
                      required={true}
                      type="radio"
                      name="membershipRadios"
                      id="radio2"
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      checked={formData.show === false}
                      onChange={() => setFormData({ ...formData, show: false })}
                    />
                  </div>
                </div>
                <CustomButton
                  type={CustomButtonTypes.BUTTON}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={submitHandler}
                >
                  Update
                </CustomButton>

                <Link to={"/admin/child-categories"}>
                  <CustomButton
                    className={CustomButtonClasses.LIGHT}
                    type={CustomButtonTypes.BUTTON}
                  >
                    Cancal
                  </CustomButton>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
